import React from 'react';
import Button from '../Button/Button';
// @ts-ignore
import checkIcon from '../../image-assets/icon.checkmark.svg';
import './ContentCard.css';

interface ContentCardProps {
  title: string;
  subtitle: string;
  buttonText: string;
  onButtonClick: () => void;
  totalKeys: number;
  isComplete: boolean;
  isLoading?: boolean;
  onCancel?: () => void;
}

const ContentCard: React.FC<ContentCardProps> = ({
  title,
  subtitle,
  buttonText,
  onButtonClick,
  totalKeys,
  isComplete,
  isLoading = false,
  onCancel
}) => {
  return (
    <div className={`content-card ${isComplete ? 'success' : ''}`}>
      <div className="content-card-text">
        <div className="content-card-title">
          {isComplete ? 'All Translations Complete' : title}
        </div>
        {!isComplete && (
          <div className="content-card-subtitle">
            {subtitle}
          </div>
        )}
      </div>
      {isComplete ? (
        <img src={checkIcon} alt="Complete" className="content-card-icon" />
      ) : (
        <div className="content-card-actions">
          {isLoading && onCancel && (
            <Button
              onClick={onCancel}
              variant="secondary"
            >
              Cancel
            </Button>
          )}
          <Button
            onClick={onButtonClick}
            disabled={isComplete || isLoading}
            isLoading={isLoading}
          >
            {buttonText}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ContentCard; 